import {
  EXPERT_TIPS_COLORS,
  EXPERT_TIPS_RESPONSIVE,
  EXPERT_TIPS_TYPOGRAPHY,
} from './constants';
import TipLinkResources from './TipLinkResources';
import TipFeedbackSection from './TipFeedbackSection';
import type { ExpertTip, FeedbackType } from '../../types/expert-tip.types';

interface TipExpandedContentProps {
  tip: ExpertTip;
  onFeedbackSubmit: (tipId: number, feedbackType: FeedbackType) => Promise<void>;
  isFeedbackSubmitting: boolean;
}

export default function TipExpandedContent({
  tip,
  onFeedbackSubmit,
  isFeedbackSubmitting,
}: TipExpandedContentProps) {
  return (
    <div
      className={`flex flex-col ${EXPERT_TIPS_RESPONSIVE.sectionGapClasses} ${EXPERT_TIPS_RESPONSIVE.cardPaddingClasses}`}
      style={{ paddingTop: 0 }}
    >
      {/* Expert info */}
      <div className="flex items-center" style={{ gap: '8px' }}>
        {tip.expert.avatarUrl ? (
          <img
            src={tip.expert.avatarUrl}
            alt={tip.expert.name}
            className={`rounded-full object-cover ${EXPERT_TIPS_RESPONSIVE.avatarSizeClasses}`}
          />
        ) : (
          <div
            className={`rounded-full flex items-center justify-center ${EXPERT_TIPS_RESPONSIVE.avatarSizeClasses}`}
            style={{ backgroundColor: EXPERT_TIPS_COLORS.lightBlue }}
          >
            <span
              className="text-white font-bold text-sm"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              {tip.expert.name.charAt(0).toUpperCase()}
            </span>
          </div>
        )}

        <div className="flex flex-col">
          <span
            className={`font-bold ${EXPERT_TIPS_TYPOGRAPHY.expertName}`}
            style={{
              fontFamily: 'DM Sans, sans-serif',
              color: EXPERT_TIPS_COLORS.textPrimary,
            }}
          >
            {tip.expert.name}
          </span>
          <span
            className={`font-medium ${EXPERT_TIPS_TYPOGRAPHY.expertSubtitle}`}
            style={{
              fontFamily: 'DM Sans, sans-serif',
              color: EXPERT_TIPS_COLORS.textSecondary,
            }}
          >
            {tip.expert.subtitle}
          </span>
        </div>
      </div>

      {/* Tip body */}
      <div
        className={`font-normal ${EXPERT_TIPS_TYPOGRAPHY.tipBody} leading-7`}
        style={{
          fontFamily: 'DM Sans, sans-serif',
          color: EXPERT_TIPS_COLORS.textPrimary,
          whiteSpace: 'pre-line',
          lineHeight: '125%',
        }}
      >
        {tip.body}
      </div>

      {/* Link resources */}
      {tip.linkResources.length > 0 && (
        <TipLinkResources linkResources={tip.linkResources} />
      )}

      {/* Feedback section */}
      <TipFeedbackSection
        tipId={tip.id}
        initialFeedback={tip.userFeedback?.feedbackType ?? null}
        onFeedbackSubmit={onFeedbackSubmit}
        isSubmitting={isFeedbackSubmitting}
      />
    </div>
  );
}
